// Resource-type aliasing, kept separate from staffPermissions.ts so that
// permissions.ts (imported by the Redux action creators) doesn't pull the whole
// api layer in through it.
//
// The backend has keyed resources inconsistently across modules — 'location',
// 'site', 'sites', 'time_location' all mean the same thing — so every lookup
// into position.resources must go through these aliases.

export type StaffResourceKind = 'teams' | 'sites' | 'paySchedules' | 'company';

export const getResourceKind = (resourceType?: string): StaffResourceKind => {
  const normalizedType = resourceType?.toLowerCase() || '';
  if (normalizedType.includes('team')) return 'teams';
  if (
    normalizedType.includes('location') ||
    normalizedType.includes('site') ||
    normalizedType.includes('time')
  ) {
    return 'sites';
  }
  if (normalizedType.includes('pay') || normalizedType.includes('schedule')) return 'paySchedules';
  return 'company';
};

export const getResourceKeysByKind = (resourceKind: StaffResourceKind): string[] => {
  if (resourceKind === 'teams') return ['teams', 'team'];
  if (resourceKind === 'sites') return ['sites', 'site', 'location', 'time_location'];
  if (resourceKind === 'paySchedules') return ['pay_schedule', 'pay_schedules', 'payschedule', 'payroll'];
  return ['company'];
};

/** Every key `position.resources` might use for this resource type. */
export const getResourceAliases = (resourceType: string): string[] => {
  const normalized = resourceType.toLowerCase();
  return Array.from(new Set([normalized, ...getResourceKeysByKind(getResourceKind(normalized))]));
};
